// extracted by mini-css-extract-plugin
export default {"deviceSelector":"styles_deviceSelector__-4E0x","deviceValue":"styles_deviceValue__87v0m","deviceOptions":"styles_deviceOptions__XDWXL"};